// extracted by mini-css-extract-plugin
module.exports = {"wrap":"gradient_wrap__DM0bn","bg":"gradient_bg__Z7IgY"};